import { TranscriptionConfig } from './types'
import { Checkbox, TextInput } from './FormControls'

interface AdvancedTabProps {
  config: TranscriptionConfig
  onChange: (config: TranscriptionConfig) => void
}

export function AdvancedTab({ config, onChange }: AdvancedTabProps) {
  const update = (key: keyof TranscriptionConfig, value: unknown) => {
    onChange({ ...config, [key]: value })
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <Checkbox
          label="V10 Transcriber"
          value={config.v9}
          onChange={(v) => update('v9', v)}
          tooltip="Use v10 transcription pipeline (recommended)"
        />

        <Checkbox
          label="Human Feel"
          value={config.humanFeel}
          onChange={(v) => update('humanFeel', v)}
          tooltip="Preserve human performance characteristics"
        />

        <Checkbox
          label="Parse BPM"
          value={config.parseBpm}
          onChange={(v) => update('parseBpm', v)}
          tooltip="Automatically detect and parse BPM from audio"
        />

        <Checkbox
          label="Disable Confidence"
          value={config.noConfidence}
          onChange={(v) => update('noConfidence', v)}
          tooltip="Disable confidence-based filtering (include all detected notes)"
        />
      </div>

      <div className="space-y-4 mt-4">
        <TextInput
          label="Text Hint"
          value={config.textHint}
          onChange={(v) => update('textHint', v)}
          placeholder="e.g., 'jazz piano solo'"
          tooltip="Optional text hint to guide transcription (genre, instrument, style)"
        />

        <div className="grid grid-cols-2 gap-4">
          <TextInput
            label="Track Name"
            value={config.trackName}
            onChange={(v) => update('trackName', v)}
            placeholder="e.g., 'Summer Vibes'"
            tooltip="Track name for MIDI metadata"
          />

          <TextInput
            label="Artist"
            value={config.artist}
            onChange={(v) => update('artist', v)}
            placeholder="e.g., 'John Smith'"
            tooltip="Artist name for MIDI metadata"
          />
        </div>

        <TextInput
          label="Log File Path"
          value={config.logFile}
          onChange={(v) => update('logFile', v)}
          placeholder="/path/to/transcription.log"
          tooltip="Optional path to save detailed transcription logs"
        />
      </div>

      <div className="p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg">
        <p className="text-xs text-amber-300">
          ⚠ Advanced settings can significantly affect processing time and output quality.
          Use defaults unless you know what you're doing.
        </p>
      </div>
    </div>
  )
}
